var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.canEdit || _vm.userIsTeacher
    ? _c(
        "section",
        {
          staticClass: "cw-block-feedback",
          class: [_vm.emptyFeedback ? "cw-block-feedback-empty" : ""],
        },
        [
          _c(
            "span",
            {
              staticClass: "sr-only",
              attrs: {
                "aria-live": "polite",
              },
            },
            [_vm._v(_vm._s(_vm.srMessage))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cw-block-features-content",
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.emptyFeedback,
                      expression: "!emptyFeedback",
                    },
                  ],
                  ref: "feedbacks",
                  staticClass: "cw-block-feedback-items",
                },
                _vm._l(_vm.feedback, function (feedback) {
                  return _c("courseware-talk-bubble", {
                    key: feedback.id,
                    attrs: {
                      payload: _vm.buildPayload(feedback),
                    },
                    on: {
                      delete: function _delete($event) {
                        return _vm.deleteFeedback(feedback)
                      },
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              !_vm.userIsTeacher && _vm.feedback.length === 0
                ? _c("courseware-companion-box", {
                    attrs: {
                      msgCompanion: _vm.$gettext(
                        "Es wurde noch keine Anmerkung hinzugefügt."
                      ),
                      mood: "pointing",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsTeacher
                ? _c(
                    "div",
                    {
                      staticClass: "cw-block-feedback-create",
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.feedbackText,
                            expression: "feedbackText",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.placeHolder,
                          spellcheck: "true",
                        },
                        domProps: {
                          value: _vm.feedbackText,
                        },
                        on: {
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.feedbackText = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          on: {
                            click: _vm.postFeedback,
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$gettext("Senden")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }